import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import lv from '@/locales/lv.json';

i18n.use(initReactI18next).init({
  resources: {
    lv: {
      translation: lv,
    },
  },
  lng: 'lv',
  fallbackLng: 'lv',
  supportedLngs: ['lv'],
  interpolation: {
    escapeValue: false,
  },
  returnNull: false,
});

export default i18n;
